import React from "react";
import styled from "../style.module.css";
import { COPPER } from "./theme";

// A hero metric with a delta badge.
const KpiCard = ({ label, value, accent = COPPER, delta }) => {
  return (
    <div className={styled.kpiCard} style={{ "--accent": accent }}>
      <div className={styled.kpiHead}>
        <p className={styled.kpiLabel}>{label}</p>
        {delta != null ? (
          <span className={delta >= 0 ? styled.deltaUp : styled.deltaDown}>
            {delta >= 0 ? "▲" : "▼"} {Math.abs(delta)}%
          </span>
        ) : (
          <span className={styled.asOfTag}>Live</span>
        )}
      </div>
      <div className={styled.kpiValue}>{value}</div>
    </div>
  );
};

export default KpiCard;
